import { h } from 'preact'
import { useState, useRef, useEffect } from 'preact/hooks'
import PropTypes from 'prop-types'

import classNames from 'lib/classNames'
import Icon from 'components/Icon'

export default function InMeetingChat({ chatMessages, sendChatMessage, isOpen, onClose }) {
  const [text, setText] = useState('')
  const messagesEndRef = useRef(null)

  useEffect(() => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [chatMessages.length])

  const handleSend = () => {
    const trimmed = text.trim()
    if (!trimmed) return
    sendChatMessage(trimmed)
    setText('')
  }

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault()
      handleSend()
    }
  }

  const panelClass = classNames('InMeetingChat', {
    open: isOpen,
  })

  if (!isOpen) return null

  return <div className={panelClass}>
    <div className="InMeetingChat-header">
      <span className="InMeetingChat-title">Chat</span>
      <button
        className="InMeetingChat-closeBtn"
        onClick={onClose}
        title="Close chat"
      >
        <Icon type="close" size="sm" />
      </button>
    </div>

    <div className="InMeetingChat-messages">
      {chatMessages.length === 0 &&
        <div className="InMeetingChat-empty">
          No messages yet. Say hello!
        </div>
      }
      {chatMessages.map((msg, i) => {
        const msgClass = classNames('InMeetingChat-message', {
          local: msg.isLocal,
        })
        return <div key={i} className={msgClass}>
          <div className="InMeetingChat-messageSender">
            {msg.isLocal ? 'You' : (msg.senderName || msg.sender)}
          </div>
          <div className="InMeetingChat-messageBubble">
            {msg.text}
          </div>
          <div className="InMeetingChat-messageTime">
            {formatTime(msg.timestamp)}
          </div>
        </div>
      })}
      <div ref={messagesEndRef} />
    </div>

    <div className="InMeetingChat-inputArea">
      <textarea
        className="InMeetingChat-input"
        placeholder="Type a message..."
        value={text}
        onInput={e => setText(e.target.value)}
        onKeyDown={handleKeyDown}
        rows={1}
      />
      <button
        className="InMeetingChat-sendBtn"
        onClick={handleSend}
        disabled={!text.trim()}
        title="Send message"
      >
        <Icon type="mail" size="sm" />
      </button>
    </div>
  </div>
}

function formatTime(timestamp) {
  if (!timestamp) return ''
  const d = new Date(timestamp)
  const h = d.getHours().toString().padStart(2, '0')
  const m = d.getMinutes().toString().padStart(2, '0')
  return `${h}:${m}`
}

InMeetingChat.propTypes = {
  chatMessages: PropTypes.array.isRequired,
  sendChatMessage: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
}
